module.exports = __webpack_public_path__ + "img/slider-bg.6f88f6ff.svg";